export const ACCOUNTING_METHOD_SELECTION_MODAL_PATH =
  'accounting-method-selection';
